module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sizeSelected),
      expression: "sizeSelected"
    }],
    staticClass: "ui fluid dropdown selection",
    staticStyle: {
      "height": "48px",
      "width": "50px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sizeSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sizeOptions), function(sizeOption, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": sizeOption
      }
    }, [_vm._v("\n      " + _vm._s(sizeOption) + "\n    ")])
  }), 0), _vm._v("\n   \n  "), (_vm.totalPages > 1) ? _c('div', _vm._l((_vm.leftPages), function(button) {
    return _c('button', {
      key: button,
      class: _vm.pageClass[button],
      on: {
        "click": function($event) {
          return _vm.jumpToPage(button)
        }
      }
    }, [_vm._v("\n      " + _vm._s(button) + "\n    ")])
  }), 0) : _vm._e(), _vm._v(" "), _vm._l((_vm.middlePages), function(button) {
    return _c('button', {
      key: button,
      class: _vm.pageClass[button],
      on: {
        "click": function($event) {
          return _vm.jumpToPage(button)
        }
      }
    }, [_vm._v("\n    " + _vm._s(button) + "\n  ")])
  }), _vm._v(" "), (_vm.totalPages > 1) ? _c('div', _vm._l((_vm.rightPages), function(button) {
    return _c('button', {
      key: button,
      class: _vm.pageClass[button],
      on: {
        "click": function($event) {
          return _vm.jumpToPage(button)
        }
      }
    }, [_vm._v("\n      " + _vm._s(button) + "\n    ")])
  }), 0) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3eff4c5c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pagination.vue
// module id = 494
// module chunks = 1